import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
import { getToken, clearAuth } from './auth'

const service = axios.create({
  // 开发环境未定义时为空，请求走 /api 由 devServer proxy 转发。
  baseURL:  '',
  timeout: 30000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 过期（超过 24 小时）时 getToken 返回 null 并自动清除登录态
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message.error(res.message || '请求失败')
      if (res.code === 401) {
        clearAuth()
        if (router.currentRoute.path !== '/login') {
          router.push('/login')
        }
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    const status = error.response && error.response.status
    // HTTP 401（未登录/登录过期）：清除登录态并跳转登录页（避免路由守卫并发触发导致 Navigation cancelled 报错）
    if (status === 401) {
      clearAuth()
      if (router.currentRoute.path !== '/login') {
        router.push('/login')
      }
    } else {
      Message.error((error.response && error.response.data && error.response.data.message) || error.message || '网络异常')
    }
    return Promise.reject(error)
  }
)

export default service
